<template>
    <div
        class="context-menu"
        ref="popper"
        v-show="opened"
        tabindex="-1"
        v-click-outside="close"
        @contextmenu.capture.prevent>

        <b-list-group v-if="opened">
            <b-list-group-item v-for="(action, i) in availableActions()"
                               @click="onClick(action)" :key="contentKey + '-' + i"
                               class="context-menu-item">
                <small>
                    <b-icon  v-if="action.icon" :icon="action.icon" class="mr-2"/>
                    <span>{{ action.title }}</span>
                </small>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
    // import Popper from 'popper.js';
    import { createPopper } from '@popperjs/core';
    import { mapGetters } from 'vuex';

    export default {
        name: "DataTableContextMenu",
        // components: { Popper },
        props: {
            actions: { type: Array, default: () => { return [] } },
            boundariesElement: {
                type: String,
                default: 'body',
            },
            contentWrapperElement: { type: String, default: 'body' }
        },
        computed: {
            ...mapGetters(['contextMenuContainerBoundaries'])
        },
        data() {
            return {
                opened: false,
                row: null,
                contentKey: this.generateContentKey(),
            }
        },
        methods: {
            generateContentKey() {
                return `${new Date().getTime()}-context-menu`
            },
            availableActions() {
                let availableActions = [];
                for (const action of this.actions) {
                    // console.log(this.row, action.availabilityCallback(this.row))
                    if (action.hasOwnProperty('availabilityCallback') && action.availabilityCallback(this.row)
                        || (!action.hasOwnProperty('availabilityCallback') && action.hasOwnProperty('available') && action.available)) {
                        availableActions.push(action)
                    }
                }
                return availableActions

            },
            onClick(action) {
                const object = action.callback(this.row['id'], this.row);
                if (action.emittedEvent) {
                    this.$emit(action.emittedEvent, this.row, object)
                }
                this.close();
            },
            open(e, row) {
                function generateGetBoundingClientRect(x = 0, y = 0) {
                  return () => ({
                    width: 0,
                    height: 0,
                    top: y,
                    right: x,
                    bottom: y,
                    left: x,
                  });
                }

                this.opened = true;
                this.row = row;
                this.contentKey = this.generateContentKey();

                const virtualElement = {
                      getBoundingClientRect: generateGetBoundingClientRect(e.clientX, e.clientY),
                    };

                const popup = this.$refs.popper;

                if (this.popper) {
                    this.popper.destroy();
                }

                this.popper = createPopper(virtualElement, popup, { placement: 'right-start' });
                this.popper.update()

            },
            close() {
                const row = {...this.row}
                this.opened = false;
                this.row = null;
                this.$emit('context-menu-closed', row)
            },

        },
        beforeDestroy() {
            if (this.popper !== undefined) {
                this.popper.destroy();
            }
        },
    }
</script>

<style scoped lang="scss">

    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";

    .context-menu {
        border: 0;
        position: fixed;
        z-index: 10999;
        overflow: hidden;
        background: $white;
        border-radius: 4px;
        box-shadow: 0 1px 10px 0 $gray-400;

        &:focus {
            outline: none;
        }
    }

    .context-menu-item {
        display: block;
        position: relative;
        background: $white;
        border-radius: 0;
        color: $black;
        text-decoration: none;
        width: 100%;
        text-align: left;
        cursor: pointer;
        padding:8px 12px;


        &:hover,
        &:focus {
           background: $primary;
           color: $white;
           outline: none;
        }
    }

        /*ul {*/
        /*  padding:0;*/
        /*  margin:0;*/
        /*}*/

</style>